export const languages = [
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' }
];

export const languagesValues = {
  en: 'English',
  es: 'Español'
};

export const warningSpanishText =
  'Algunas funciones no están disponibles en español en este momento. Vamos a añadir más funciones en español en los próximos meses. Si necesita ayuda para entender su información de paciente, póngase en contacto con la clínica de su proveedor. Si necesita asistencia técnica, póngase en contacto con nuestro equipo de asistencia';

export const switcherTranslations = {
  en: {
    title: 'Preferred Language',
    buttonText: 'Apply',
    buttonTextError: 'Close',
    errorText: 'Language preferences cannot be retrieved at this time. Please try again later.'
  },
  es: {
    title: 'Idioma preferido',
    buttonText: 'Aplicar',
    buttonTextError: 'Cerrar',
    errorText:
      'No se pueden recuperar las preferencias de idioma en este momento. Inténtelo más tarde.'
  }
};
